import SurgicalIcon from './surgical.png';
import DoctorIcon from './doctor-appointments.png';
import USFDAIcon from './USFDA-approved.png';
import HassleFreeIcon from './hassle-free.png';
import ValueAddedIcon from './value-added.png';
import NoCostEMIIcon from './no-cost.png';
import FreeFollowUpIcon from './free-follow-up.png';
import FreeCabIcon from './free-cab.png';
import { StaticImageData } from 'next/image';
import { BasicCard } from '../../product';
const whoChooseThisData: { image: StaticImageData; title: string }[] = [
  {
    image: SurgicalIcon,
    title: 'Surgical experts with 10+ years experience',
  },
  { image: DoctorIcon, title: 'Free doctor appointments' },
  { image: USFDAIcon, title: 'USFDA-approved surgical procedures' },
  { image: HassleFreeIcon, title: 'Hassle-free insurance claims' },
  { image: ValueAddedIcon, title: 'Value added insurance services' },
  { image: NoCostEMIIcon, title: 'No-cost EMI Services' },
  { image: FreeFollowUpIcon, title: 'Free follow-ups post-surgery' },
  { image: FreeCabIcon, title: 'Free cab for pick & drop on surgery day' },
];

export const WhoChoosesThis = () => {
  return (
    <div className="mt-18">
      <div className="text-title-3 font-bold ">Why choose this service?</div>
      <div className="mt-7 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {whoChooseThisData.map((data, idx) => {
          return <BasicCard key={idx} image={data.image} title={data.title} />;
        })}
      </div>
    </div>
  );
};
